/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class KnowledgeHubFinAsCodeRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(KnowledgeHubFinAsCodeRoute);
